<template>
    <templateBase
        module-name="Novidades"
        :title="page.title"
        :subtitle="page.subtitle"
    >
        <template #sidebar-left><side-menu v-if="permissions" /></template>

        <template v-if="pageNewList" #show-actions>
            <div v-if="permissions" class="container-show-actions">
                <span>Buscar</span>
                <div class="search-box"><ui-search-box placeholder="Pesquise por assunto" /></div>

                <div class="button-new">
                    <ui-button design="md primary" @click="newNews">
                        Criar Novidade <i class="fal fa-plus right" />
                    </ui-button>
                </div>
            </div>
        </template>

        <template #page>
            <div class="page-container">
                <router-view />
            </div>
        </template>
    </templateBase>
</template>

<script>
import templateBase from '@/templates/page-configurations'
import sideMenu from './components/side-menu'
import { uiSearchBox } from '@/components/ui'
import { uiButton } from '@/components/ui/buttons'
import { mapGetters } from 'vuex'

export default {
	name: 'news-main',

	components: { templateBase, sideMenu, uiSearchBox, uiButton },

	data() {
		return {
			page: {
				title: this.$route.meta.title,
				subtitle: this.$route.meta.subtitle,
			},
            pageNewList: true,
            permissions: true
		}

	},

    computed: {
        ...mapGetters('auth', {
            user: 'getUser'
        })
    },

    watch: {
        $route(newRoute) {
            if(newRoute.name == 'news.list') {
                this.pageNewList = true
            } else {
                this.pageNewList = false
            }
        }
    },

    mounted() {
        this.setPermissions(this.user.user_group)
    },

    methods: {
        setPermissions(user) {
            switch (user) {
                case 'broker':
                case 'manager':
                case 'supervisor':
                    this.permissions = false
                    break
            }
        },

        newNews() {
            this.$router.push({ name: 'news.add' })
        }
    }
}
</script>

<style lang="stylus" scoped>
@import 'styles.styl';
</style>
